<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="FMEPI">The past is never dead. It’s not even past.</p>
<p class="FMEPS">—William Faulkner, <span class="ePub-I">Requiem for a Nun</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?3500f19b